// Мини-задания правил B1, уроки 36–55: пересказ, цель и причина, -meye başlamak,
// -mesini istemek, -mek üzere, пассив + клауза (тикет 06 .scratch/grammar-unify).
import type { MiniSet } from './types'

export const MINI_B1_1: MiniSet[] = [
  // b1-l036
  {
    rule: 'reported-speech-diye',
    explain: 'Чужие слова турок чаще всего передаёт прямой цитатой: сначала сами слова, потом diye и глагол речи - "Kaç yaşındasın?" diye sordu. Diye никогда не меняется; если нужно просто "сказал", хватает dedi - без diye.',
    examples: [
      {
        parts: [
          { text: '"Yarın gelirim" ', label: '', why: '' },
          { text: 'diye', label: 'связка после цитаты', why: 'diye - "говоря", от demek; не меняется' },
          { text: ' söyledi.', label: 'глагол речи', why: 'глагол - после цитаты, в конце' },
        ],
        ru: 'Он сказал: "Завтра приду".',
      },
      {
        parts: [
          { text: '"Dikkat et!" ', label: '', why: '' },
          { text: 'diye', label: 'связка после цитаты', why: 'перед любым глаголом речи, кроме dedi' },
          { text: ' bağırdı.', label: 'глагол речи', why: 'bağırdı - "крикнул"' },
        ],
        ru: 'Он крикнул: "Осторожно!"',
      },
    ],
    items: [
      {
        kind: 'transform', source: 'Он спросил: "Сколько тебе лет?"', instruction: 'Переведите: цитата, связка, глагол речи',
        answer: '"Kaç yaşındasın?" diye sordu.', variants: [], blankWhole: true,
        breakdown: [{ text: 'diye', label: 'связка после цитаты', why: 'перед sordu, bağırdı и другими глаголами речи встаёт diye' }], d: 1,
      },
      {
        kind: 'transform', source: 'Он крикнул: "Осторожно!"', instruction: 'Переведите: цитата, связка, глагол речи',
        answer: '"Dikkat et!" diye bağırdı.', variants: [], blankWhole: true,
        breakdown: [{ text: 'diye', label: 'связка после цитаты', why: 'bağırdı - не dedi, значит, нужна связка diye' }], d: 1,
      },
      {
        kind: 'transform', source: 'Он сказал: "Я иду".', instruction: 'Переведите одним словом после цитаты: просто "сказал"',
        answer: '"Geliyorum" dedi.', variants: ['"Geliyorum" diye söyledi.'], blankWhole: true,
        breakdown: [{ text: 'dedi', label: 'просто "сказал"', why: 'dedi стоит сам по себе, diye с ним не нужен' }], d: 1,
      },
      {
        kind: 'transform', source: 'Учитель спросил: "Почему опоздал?"', instruction: 'Переведите: после цитаты - связка и "спросил"',
        answer: 'Öğretmen "Neden geç kaldın?" diye sordu.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'diye', label: 'связка', why: 'не "dedi sordu": dedi рядом с другим глаголом речи не ставят' },
          { text: ' sordu', label: 'глагол речи', why: 'глагол - в конце, после цитаты' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Мама сказала: "Я иду".', instruction: 'Переведите: в цитате - слова мамы как есть',
        answer: 'Annem "Ben geliyorum" dedi.', variants: [],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'iyor', label: 'настоящее', why: '' },
          { text: 'um', label: 'я', why: 'в цитате остаётся лицо того, кто говорил: мама сказала "я", а не "o geliyor"' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Тебе звонил какой-то Ахмет.', instruction: 'Переведите: "какой-то Ахмет" - через diye',
        answer: 'Ahmet diye biri seni aradı.', variants: [], blankWhole: true,
        breakdown: [{ text: 'diye', label: '"по имени"', why: 'Ahmet diye biri - буквально "кто-то, говоря "Ахмет""' }], d: 2,
      },
      {
        kind: 'transform', source: 'Deniz: "Sessiz ol!"', sourceRu: 'Дениз: "Тише!"', instruction: 'Перескажите цитатой: Дениз прошептала',
        answer: 'Deniz "Sessiz ol!" diye fısıldadı.', variants: [],
        breakdown: [
          { text: 'diye', label: 'связка', why: 'перед глаголом речи, кроме dedi, - diye' },
          { text: ' fısıldadı', label: 'глагол речи', why: 'fısıldadı - "прошептала", в конце' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я подумал: "Опоздал на автобус".', instruction: 'Переведите: мысль - тоже цитатой',
        answer: '"Otobüsü kaçırdım" diye düşündüm.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'diye', label: 'связка', why: 'diye работает и с мыслями' },
          { text: ' düşündüm', label: 'глагол', why: 'düşündüm - "я подумал", в конце' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Он поблагодарил: "Спасибо за всё".', instruction: 'Переведите: цитата, связка, "поблагодарил"',
        answer: '"Her şey için sağ ol" diye teşekkür etti.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'diye', label: 'связка', why: 'teşekkür etti - не dedi, значит, нужна связка' },
          { text: ' teşekkür etti', label: 'глагол речи', why: 'в конце, после diye' },
        ], d: 3,
      },
    ],
  },

  // b1-l037
  {
    rule: 'reported-speech-digini-soylemek',
    explain: 'Чтобы пересказать чужие слова своими словами, всю фразу превращают в форму на -dığını и ставят перед söyledi, duydum, sanıyorum: Ali yorgun olduğunu söyledi. Если речь о будущем - -eceğini: Yarın geleceğini söyledi. Окончание показывает, чья это мысль: olduğum - моя, olduğun - твоя, olduğu - его.',
    examples: [
      {
        parts: [
          { text: 'Yorgun ol', label: '', why: '' },
          { text: 'duğ', label: '-dığı "то, что"', why: 'имя или прилагательное берёт olduğu' },
          { text: 'unu', label: 'его + что?', why: '-u - "его" (Али о себе), -nu - дополнение к söyledi' },
          { text: ' söyledi.', label: '', why: '' },
        ],
        ru: 'Он сказал, что устал.',
      },
      {
        parts: [
          { text: 'Yarın gel', label: '', why: '' },
          { text: 'eceğ', label: '-eceği: будущее', why: '"Yarın geleceğim" - о будущем, значит -eceği' },
          { text: 'ini', label: 'его + что?', why: '' },
          { text: ' söyledi.', label: '', why: '' },
        ],
        ru: 'Он сказал, что завтра придёт.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'ol', baseRu: 'быть', task: '"то, что" · его · что?',
        context: { tr: 'Ali yorgun ___ söyledi.', ru: 'Али сказал, что устал.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'dığ', 'dük'], label: '-dığı "то, что"', why: 'после "o" - "u"' },
          { answer: 'unu', options: ['unu', 'umu', 'u'], label: 'его + что?', why: 'устал Али, а не я: -umu значило бы "что Я устал"' },
        ],
        answer: 'olduğunu', d: 1,
      },
      {
        kind: 'affix', base: 'git', baseRu: 'идти, ехать', task: '"то, что" · его · что?',
        context: { tr: 'Dün sinemaya ___ söyledi.', ru: 'Он сказал, что вчера ходил в кино.' },
        slots: [
          { answer: 'git', options: [], label: '', why: '' },
          { answer: 'tiğ', options: ['tiğ', 'diğ', 'eceğ'], label: '-dığı "то, что"', why: 'после глухой "t" - "t"; dün - прошлое (dün gitti), значит -dığı' },
          { answer: 'ini', options: ['ini', 'imi', 'i'], label: 'его + что?', why: '' },
        ],
        answer: 'gittiğini', d: 1,
      },
      {
        kind: 'affix', base: 'gel', baseRu: 'приходить', task: 'будущее · его · что?',
        context: { tr: 'Yarın ___ söyledi.', ru: 'Он сказал, что завтра придёт.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'eceğ', options: ['eceğ', 'diğ', 'ecek'], label: '-eceği: будущее', why: 'о будущем - -eceği; перед гласной k становится ğ' },
          { answer: 'ini', options: ['ini', 'imi', 'i'], label: 'его + что?', why: '' },
        ],
        answer: 'geleceğini', d: 1,
      },
      {
        kind: 'affix', base: 'taşın', baseRu: 'переезжать', task: '"то, что" · твоё · что?',
        context: { tr: '___ duydum.', ru: 'Я слышал, что ты переехал.' },
        slots: [
          { answer: 'taşın', options: [], label: '', why: '' },
          { answer: 'dığ', options: ['dığ', 'diğ', 'tığ'], label: '-dığı "то, что"', why: 'после "ı" - "ı"; после звонкой "n" - "d"' },
          { answer: 'ını', options: ['ını', 'ımı', 'ı'], label: 'твоё + что?', why: 'переехал ты - -ın; duydum спрашивает "что?" - -ı' },
        ],
        answer: 'taşındığını', d: 1,
      },
      {
        kind: 'transform', source: 'Ali: "Yorgunum."', sourceRu: 'Али: "Я устал".', instruction: 'Перескажите без кавычек: Али сказал, что устал',
        answer: 'Ali yorgun olduğunu söyledi.', variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duğ', label: '-dığı "то, что"', why: 'прилагательное берёт olduğu' },
          { text: 'unu', label: 'его + что?', why: 'в пересказе "я" Али становится "его": не olduğumu' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Ali: "Sigara içmiyorum."', sourceRu: 'Али: "Я не курю".', instruction: 'Перескажите: Али сказал, что не курит',
        answer: 'Ali sigara içmediğini söyledi.', variants: [],
        breakdown: [
          { text: 'iç', label: '', why: '' },
          { text: 'me', label: 'не', why: 'отрицание - сразу после основы' },
          { text: 'diğ', label: '-dığı "то, что"', why: 'настоящее и прошлое в пересказе - одна форма -dığı' },
          { text: 'ini', label: 'его + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Ayşe evlendi.', sourceRu: 'Айше вышла замуж.', instruction: 'Скажите: "Я слышал, что Айше вышла замуж" (... duydum)',
        answer: 'Ayşe\'nin evlendiğini duydum.', variants: [],
        breakdown: [
          { text: 'Ayşe\'nin ', label: 'чья мысль - родительный', why: 'в пересказе другой человек - он в родительном: Ayşe\'nin' },
          { text: 'evlen', label: '', why: '' },
          { text: 'diğ', label: '-dığı "то, что"', why: 'после звонкой "n" - "d"' },
          { text: 'ini', label: 'её + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Ali: "Ankara\'da oturuyorum."', sourceRu: 'Али: "Я живу в Анкаре".', instruction: 'Перескажите: Али сказал, что живёт в Анкаре',
        answer: 'Ali Ankara\'da oturduğunu söyledi.', variants: [],
        breakdown: [
          { text: 'otur', label: '', why: '' },
          { text: 'duğ', label: '-dığı "то, что"', why: '-yor в пересказе тоже становится -dığı' },
          { text: 'unu', label: 'его + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я думал, что ты дома (а тебя не было).', instruction: 'Переведите: "думал, а оказалось не так" - sandım',
        answer: 'Evde olduğunu sandım.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duğ', label: '-dığı "то, что"', why: 'место - с olduğu: evde olduğunu' },
          { text: 'unu', label: 'твоё + что?', why: 'дома - ты: -un; sandım спрашивает "что?" - -u' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Onlar: "Yorgunuz."', sourceRu: 'Они: "Мы устали".', instruction: 'Перескажите: они сказали, что устали',
        answer: 'Yorgun olduklarını söylediler.', variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duk', label: '-dığı "то, что"', why: 'перед -ları k не смягчается' },
          { text: 'ları', label: 'их', why: '"мы" говорящих в пересказе - "их"' },
          { text: 'nı', label: 'что?', why: 'дополнение к söylediler' },
        ], d: 3,
      },
    ],
  },

  // b1-l038
  {
    rule: 'reported-speech-questions-requests',
    explain: 'Чужой вопрос пересказывают так же, как чужие слова, - через -dığını, только в конце стоит sordu. Вопросительное слово остаётся на месте: Nerede oturduğumu sordu. А вопрос "да или нет" строится парой: глагол с -ıp плюс тот же глагол с отрицанием -madığını - Gelip gelmediğimi sordu.',
    examples: [
      {
        parts: [
          { text: 'Nerede otur', label: '', why: '' },
          { text: 'duğ', label: '-dığı "то, что"', why: 'вопросительное слово остаётся, глагол - в -dığı' },
          { text: 'umu', label: 'моё + что?', why: 'спросили про меня - -um' },
          { text: ' sordu.', label: '', why: '' },
        ],
        ru: 'Он спросил, где я живу.',
      },
      {
        parts: [
          { text: 'Gel', label: '', why: '' },
          { text: 'ip', label: '-ıp', why: 'первый глагол голый, с -ıp' },
          { text: ' gel', label: '', why: '' },
          { text: 'me', label: 'не', why: 'второй - тот же глагол с отрицанием' },
          { text: 'diğimi', label: '-dığı + моё + что?', why: 'все окончания - только у второго глагола' },
          { text: ' sordu.', label: '', why: '' },
        ],
        ru: 'Он спросил, пришёл ли я.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'otur', baseRu: 'жить, сидеть', task: '"то, что" · моё · что?',
        context: { tr: 'Nerede ___ sordu.', ru: 'Он спросил, где я живу.' },
        slots: [
          { answer: 'otur', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'dığ', 'tuğ'], label: '-dığı "то, что"', why: 'после "u" - "u"; после звонкой "r" - "d"' },
          { answer: 'umu', options: ['umu', 'unu', 'u'], label: 'моё + что?', why: 'спросили, где живу я - -um' },
        ],
        answer: 'oturduğumu', d: 1,
      },
      {
        kind: 'affix', base: 'gel', baseRu: 'приходить', task: 'будущее · моё · что?',
        context: { tr: 'Ne zaman ___ sordu.', ru: 'Он спросил, когда я приду.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'eceğ', options: ['eceğ', 'diğ', 'ecek'], label: '-eceği: будущее', why: '"Ne zaman geleceksin?" - о будущем' },
          { answer: 'imi', options: ['imi', 'ini', 'i'], label: 'моё + что?', why: '' },
        ],
        answer: 'geleceğimi', d: 1,
      },
      {
        kind: 'affix', base: 'ol', baseRu: 'быть', task: '"то, что" · моё · что?',
        context: { tr: 'Kaç yaşında ___ sordu.', ru: 'Он спросил, сколько мне лет.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'dığ', 'up'], label: '-dığı "то, что"', why: 'с вопросительным словом пара -ıp не нужна' },
          { answer: 'umu', options: ['umu', 'unu', 'u'], label: 'моё + что?', why: '' },
        ],
        answer: 'olduğumu', d: 1,
      },
      {
        kind: 'transform', source: '"Geldin mi?"', sourceRu: '"Ты пришёл?"', instruction: 'Перескажите вопрос: он спросил, пришёл ли я',
        answer: 'Gelip gelmediğimi sordu.', variants: ['Bana gelip gelmediğimi sordu.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'ip', label: '-ıp', why: 'mi в пересказе исчезает - вместо него пара глаголов' },
          { text: ' gel', label: '', why: '' },
          { text: 'me', label: 'не', why: '' },
          { text: 'diğ', label: '-dığı', why: '' },
          { text: 'imi', label: 'моё + что?', why: 'окончания - только у второго глагола' },
        ], d: 2,
      },
      {
        kind: 'transform', source: '"Evde misin?"', sourceRu: '"Ты дома?"', instruction: 'Перескажите вопрос: он спросил, дома ли я',
        answer: 'Evde olup olmadığımı sordu.', variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'up', label: '-ıp', why: 'для имени и места - olup olmadığı' },
          { text: ' ol', label: '', why: '' },
          { text: 'ma', label: 'не', why: '' },
          { text: 'dığ', label: '-dığı', why: '' },
          { text: 'ımı', label: 'моё + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: '"Kim aradı?"', sourceRu: '"Кто звонил?"', instruction: 'Перескажите вопрос: он спросил, кто звонил',
        answer: 'Kimin aradığını sordu.', variants: [],
        breakdown: [
          { text: 'Kimin ', label: 'кто - родительный', why: 'у придаточного свой исполнитель - он в родительном: kimin' },
          { text: 'ara', label: '', why: '' },
          { text: 'dığ', label: '-dığı', why: '' },
          { text: 'ını', label: 'его + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: '"Yarın gelecek misin?"', sourceRu: '"Ты придёшь завтра?"', instruction: 'Перескажите вопрос: он спросил, приду ли я завтра',
        answer: 'Yarın gelip gelmeyeceğimi sordu.', variants: ['Bana yarın gelip gelmeyeceğimi sordu.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'ip', label: '-ıp', why: '' },
          { text: ' gel', label: '', why: '' },
          { text: 'me', label: 'не', why: '' },
          { text: 'yeceğ', label: '-eceği: будущее', why: 'о будущем - -ıp -mayacağı' },
          { text: 'imi', label: 'моё + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Не знаю, придёт ли он.', instruction: 'Переведите: "ли" - парой глаголов',
        answer: 'Gelip gelmeyeceğini bilmiyorum.', variants: ['Onun gelip gelmeyeceğini bilmiyorum.'], blankWhole: true,
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'ip', label: '-ıp', why: 'не eğer: eğer значит только "если"' },
          { text: ' gel', label: '', why: '' },
          { text: 'me', label: 'не', why: '' },
          { text: 'yeceğ', label: '-eceği: будущее', why: '' },
          { text: 'ini', label: 'его + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я не понял, чего он хочет.', instruction: 'Переведите: "чего хочет" - в -dığı',
        answer: 'Ne istediğini anlamadım.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'iste', label: '', why: '' },
          { text: 'diğ', label: '-dığı "то, что"', why: 'та же конструкция - и после anlamadım' },
          { text: 'ini', label: 'его + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Он спросил, пью ли я чай.', instruction: 'Переведите: "ли" - парой глаголов',
        answer: 'Çay içip içmediğimi sordu.', variants: ['Bana çay içip içmediğimi sordu.'], blankWhole: true,
        breakdown: [
          { text: 'iç', label: '', why: '' },
          { text: 'ip', label: '-ıp', why: '' },
          { text: ' iç', label: '', why: '' },
          { text: 'me', label: 'не', why: '' },
          { text: 'diğ', label: '-dığı', why: '' },
          { text: 'imi', label: 'моё + что?', why: '' },
        ], d: 3,
      },
    ],
  },

  // b1-l039
  {
    rule: 'purpose-mak-icin-vs-sin-diye',
    explain: 'Русское "чтобы" по-турецки бывает двух видов. Если второе действие делает тот же человек - -mek için: Türkçe öğrenmek için buraya geldim. Если другой - глагол в форме "пусть он" на -sın, а за ней diye: Herkes duysun diye yüksek sesle konuştum.',
    examples: [
      {
        parts: [
          { text: 'Herkes duy', label: '', why: '' },
          { text: 'sun', label: '"пусть он"', why: 'слышат все - другой человек; после "u" - -sun' },
          { text: ' diye', label: '"чтобы"', why: 'diye - "с мыслью: пусть..."' },
          { text: ' yüksek sesle konuştum.', label: '', why: '' },
        ],
        ru: 'Я говорил громко, чтобы все слышали.',
      },
      {
        parts: [
          { text: 'Unut', label: '', why: '' },
          { text: 'ma', label: 'не', why: '"чтобы не" - -masın' },
          { text: 'sın', label: '"пусть он"', why: 'после "a" - -sın' },
          { text: ' diye ona mesaj attım.', label: '', why: '' },
        ],
        ru: 'Я написал ему, чтобы он не забыл.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'duy', baseRu: 'слышать', task: '"пусть он" (-sın)',
        context: { tr: 'Herkes ___ diye yüksek sesle konuştum.', ru: 'Я говорил громко, чтобы все слышали.' },
        slots: [
          { answer: 'duy', options: [], label: '', why: '' },
          { answer: 'sun', options: ['sun', 'sın', 'sün'], label: '"пусть он"', why: 'после "u" - "u"' },
        ],
        answer: 'duysun', d: 1,
      },
      {
        kind: 'affix', base: 'dinlen', baseRu: 'отдыхать', task: '"пусть он" (-sın)',
        context: { tr: 'Annem ___ diye yemeği ben yaptım.', ru: 'Ужин приготовил я, чтобы мама отдохнула.' },
        slots: [
          { answer: 'dinlen', options: [], label: '', why: '' },
          { answer: 'sin', options: ['sin', 'sın', 'sün'], label: '"пусть он"', why: 'после "e" - "i"' },
        ],
        answer: 'dinlensin', d: 1,
      },
      {
        kind: 'affix', base: 'unut', baseRu: 'забывать', task: 'не · "пусть он" (-sın)',
        context: { tr: '___ diye ona mesaj attım.', ru: 'Я написал ему, чтобы он не забыл.' },
        slots: [
          { answer: 'unut', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'mı'], label: 'не', why: 'после "u" - -ma' },
          { answer: 'sın', options: ['sın', 'sun', 'sin'], label: '"пусть он"', why: 'после "a" - "ı"' },
        ],
        answer: 'unutmasın', d: 1,
      },
      {
        kind: 'transform', source: 'Я приехал сюда, чтобы выучить турецкий.', instruction: 'Переведите: учу я сам - какое "чтобы"?',
        answer: 'Türkçe öğrenmek için buraya geldim.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'öğren', label: '', why: '' },
          { text: 'mek', label: '-mek', why: 'второе действие делает тот же человек - -mek için' },
          { text: ' için', label: '"чтобы"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'O gelmek için yemek yaptım.', instruction: 'Исправьте: готовлю я, а прийти должен он',
        answer: 'O gelsin diye yemek yaptım.', variants: [],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'sin', label: '"пусть он"', why: 'у -mek için нет места для другого человека - нужно -sın diye' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Я закрыл дверь, чтобы кошка не убежала.', instruction: 'Переведите: убегает кошка - другое "чтобы"',
        answer: 'Kedi kaçmasın diye kapıyı kapattım.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kaç', label: '', why: '' },
          { text: 'ma', label: 'не', why: '"чтобы не" - -masın' },
          { text: 'sın', label: '"пусть он"', why: 'после "a" - "ı"' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Я говорю громко, чтобы дедушка слышал.', instruction: 'Переведите: слышит дедушка - другой человек',
        answer: 'Dedem duysun diye yüksek sesle konuşuyorum.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'duy', label: '', why: '' },
          { text: 'sun', label: '"пусть он"', why: 'после "u" - "u"' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я рано ложусь, чтобы рано вставать.', instruction: 'Переведите: встаю я сам',
        answer: 'Erken kalkmak için erken yatıyorum.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kalk', label: '', why: '' },
          { text: 'mak', label: '-mek', why: 'тот же человек - -mek için; после "a" - -mak' },
          { text: ' için', label: '"чтобы"', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Мы выключили телевизор, чтобы дети уснули.', instruction: 'Переведите: засыпают дети - другое "чтобы"',
        answer: 'Çocuklar uyusun diye televizyonu kapattık.', variants: ['Çocuklar uyusunlar diye televizyonu kapattık.'], blankWhole: true,
        breakdown: [
          { text: 'uyu', label: '', why: '' },
          { text: 'sun', label: '"пусть он"', why: 'для "они" чаще хватает -sın' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Geç kalmamak için taksiye bindik.', sourceRu: 'Мы взяли такси, чтобы не опоздать.', instruction: 'Скажите то же через diye - форма для "мы"',
        answer: 'Geç kalmayalım diye taksiye bindik.', variants: [],
        breakdown: [
          { text: 'kal', label: '', why: '' },
          { text: 'ma', label: 'не', why: '' },
          { text: 'yalım', label: '"давайте мы"', why: 'для "я" и "мы" - форма -eyim / -elim' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 3,
      },
    ],
  },

  // b1-l040
  {
    rule: 'cause-digi-icin-yuzunden-dolayi',
    explain: 'Причину можно назвать целым действием - тогда -dığı için: Yorgun olduğum için erken yattım. А можно одним существительным: trafik yüzünden - "из-за пробок", yağmurdan dolayı (перед dolayı нужен -den), kar nedeniyle - официальное "по причине снега". Причина стоит впереди, результат - в конце.',
    examples: [
      {
        parts: [
          { text: 'Yorgun ol', label: '', why: '' },
          { text: 'duğ', label: '-dığı', why: 'после -dığı için - причина, "потому что"' },
          { text: 'um', label: 'моё', why: '' },
          { text: ' için', label: '"потому что"', why: '' },
          { text: ' erken yattım.', label: '', why: '' },
        ],
        ru: 'Я рано лёг, потому что устал.',
      },
      {
        parts: [
          { text: 'Yağmur', label: '', why: '' },
          { text: 'dan', label: 'откуда? (-den)', why: 'перед dolayı обязательно -den' },
          { text: ' dolayı', label: '"из-за"', why: 'нейтральное "из-за"' },
          { text: ' maçı iptal ettiler.', label: '', why: '' },
        ],
        ru: 'Из-за дождя матч отменили.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'ol', baseRu: 'быть', task: 'причина (-dığı) · его',
        context: { tr: 'Hasta ___ için gelmedi.', ru: 'Он не пришёл, потому что болеет.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'mak', 'dığ'], label: '-dığı: причина', why: 'с -mak için было бы "чтобы" - цель; причина - -dığı' },
          { answer: 'u', options: ['u', 'um', 'un'], label: 'его', why: 'болеет он' },
        ],
        answer: 'olduğu', d: 1,
      },
      {
        kind: 'affix', base: 'ol', baseRu: 'быть', task: 'причина (-dığı) · моё',
        context: { tr: 'Yorgun ___ için erken yattım.', ru: 'Я рано лёг, потому что устал.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'mak', 'dük'], label: '-dığı: причина', why: 'после "o" - "u"' },
          { answer: 'um', options: ['um', 'u', 'un'], label: 'моё', why: 'устал я - -um' },
        ],
        answer: 'olduğum', d: 1,
      },
      {
        kind: 'affix', base: 'yağmur', baseRu: 'дождь', task: 'откуда? (-den) перед dolayı',
        context: { tr: '___ dolayı maçı iptal ettiler.', ru: 'Из-за дождя матч отменили.' },
        slots: [
          { answer: 'yağmur', options: [], label: '', why: '' },
          { answer: 'dan', options: ['dan', 'den', 'da'], label: 'откуда? (-den)', why: 'перед dolayı обязательно -den; после "u" - "a"' },
        ],
        answer: 'yağmurdan', d: 1,
      },
      {
        kind: 'affix', base: 'et', baseRu: 'делать (yardım etmek)', task: 'причина (-dığı) · ваше',
        context: { tr: 'Yardım ___ için teşekkürler.', ru: 'Спасибо, что помогли.' },
        slots: [
          { answer: 'et', options: [], label: '', why: '' },
          { answer: 'tiğ', options: ['tiğ', 'diğ', 'mek'], label: '-dığı: причина', why: 'после глухой "t" - "t"; "спасибо, что..." - это причина' },
          { answer: 'iniz', options: ['iniz', 'imiz', 'in'], label: 'ваше', why: 'помогли вы' },
        ],
        answer: 'ettiğiniz', d: 1,
      },
      {
        kind: 'transform', source: 'Я не пришёл, потому что работал.', instruction: 'Переведите: причина - действие',
        answer: 'Çalıştığım için gelmedim.', variants: [],
        breakdown: [
          { text: 'çalış', label: '', why: '' },
          { text: 'tığ', label: '-dığı: причина', why: 'не çalışmak için - это "чтобы работать"; после глухой "ş" - "t"' },
          { text: 'ım', label: 'моё', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Я опоздал из-за пробок.', instruction: 'Переведите: пробки виноваты - какой послелог?',
        answer: 'Trafik yüzünden geç kaldım.', variants: ['Trafikten dolayı geç kaldım.', 'Trafik nedeniyle geç kaldım.'], blankWhole: true,
        breakdown: [{ text: 'yüzünden', label: '"из-за" (виноват)', why: 'yüzünden - когда кто-то или что-то виноват; падеж не нужен' }], d: 2,
      },
      {
        kind: 'transform', source: 'Sis dolayı uçuşu iptal ettiler.', sourceRu: 'Из-за тумана рейс отменили.', instruction: 'Исправьте ошибку перед dolayı',
        answer: 'Sisten dolayı uçuşu iptal ettiler.', variants: [],
        breakdown: [
          { text: 'sis', label: '', why: '' },
          { text: 'ten', label: 'откуда? (-den)', why: 'перед dolayı обязательно -den; после глухой "s" - "t"' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Из-за снега школы закрыты (так пишут в новостях).', instruction: 'Переведите: официальное "по причине"',
        answer: 'Kar nedeniyle okullar kapalı.', variants: [], blankWhole: true,
        breakdown: [{ text: 'nedeniyle', label: '"по причине"', why: 'nedeniyle - официальное слово новостей и объявлений' }], d: 2,
      },
      {
        kind: 'transform', source: 'Мы нашли место, потому что вышли рано.', instruction: 'Переведите: причина - впереди',
        answer: 'Erken çıktığımız için yer bulduk.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'tığ', label: '-dığı: причина', why: 'после глухой "k" - "t"' },
          { text: 'ımız', label: 'наше', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я ложусь сейчас, потому что завтра рано вставать.', instruction: 'Переведите: причина в будущем',
        answer: 'Yarın erken kalkacağım için şimdi yatıyorum.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kalk', label: '', why: '' },
          { text: 'acağ', label: '-eceği: причина в будущем', why: 'о будущей причине - -eceği için' },
          { text: 'ım', label: 'моё', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Мы тебя не ждали, потому что ты опоздал.', instruction: 'Переведите: причина - впереди',
        answer: 'Geç kaldığın için seni beklemedik.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kal', label: '', why: '' },
          { text: 'dığ', label: '-dığı: причина', why: '' },
          { text: 'ın', label: 'твоё', why: 'опоздал ты' },
        ], d: 3,
      },
    ],
  },

  // b1-l041
  {
    rule: 'purpose-cause-nuance-review',
    explain: '"Зачем?" смотрит вперёд, на цель: -mek için (тот же человек) или -sın diye (другой). "Почему?" смотрит назад, на причину: -dığı için или послелог - yüzünden, -den dolayı, nedeniyle. İçin стоит в обоих случаях - решает то, что перед ним.',
    examples: [
      {
        parts: [
          { text: 'Gör', label: '', why: '' },
          { text: 'mek', label: '-mek: цель', why: '-mek için - "чтобы"' },
          { text: ' için geldim.', label: '', why: '' },
        ],
        ru: 'Я пришёл, чтобы увидеть.',
      },
      {
        parts: [
          { text: 'Gör', label: '', why: '' },
          { text: 'düğ', label: '-dığı: причина', why: '-dığı için - "потому что"' },
          { text: 'üm', label: 'моё', why: '' },
          { text: ' için biliyorum.', label: '', why: '' },
        ],
        ru: 'Я знаю, потому что видел.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'gör', baseRu: 'видеть', task: 'цель: "чтобы"',
        context: { tr: '___ için geldim.', ru: 'Я пришёл, чтобы увидеть.' },
        slots: [
          { answer: 'gör', options: [], label: '', why: '' },
          { answer: 'mek', options: ['mek', 'düğüm', 'sün'], label: '-mek: цель', why: 'вставляется "чтобы", вижу я сам - -mek için' },
        ],
        answer: 'görmek', d: 1,
      },
      {
        kind: 'affix', base: 'gör', baseRu: 'видеть', task: 'причина: "потому что" · моё',
        context: { tr: '___ için biliyorum.', ru: 'Я знаю, потому что видел.' },
        slots: [
          { answer: 'gör', options: [], label: '', why: '' },
          { answer: 'düğ', options: ['düğ', 'mek', 'sün'], label: '-dığı: причина', why: 'подходит только "потому что" - -dığı için' },
          { answer: 'üm', options: ['üm', 'ün', 'ü'], label: 'моё', why: '' },
        ],
        answer: 'gördüğüm', d: 1,
      },
      {
        kind: 'affix', base: 'kalk', baseRu: 'вставать', task: 'цель: "чтобы"',
        context: { tr: 'Erken ___ için erken yattım.', ru: 'Я рано лёг, чтобы рано встать.' },
        slots: [
          { answer: 'kalk', options: [], label: '', why: '' },
          { answer: 'mak', options: ['mak', 'tığım', 'sın'], label: '-mek: цель', why: 'встаю я сам, и это цель - -mak için' },
        ],
        answer: 'kalkmak', d: 1,
      },
      {
        kind: 'affix', base: 'kalk', baseRu: 'вставать', task: 'причина: "потому что" · моё',
        context: { tr: 'Erken ___ için yorgunum.', ru: 'Я устал, потому что рано встал.' },
        slots: [
          { answer: 'kalk', options: [], label: '', why: '' },
          { answer: 'tığ', options: ['tığ', 'mak', 'dığ'], label: '-dığı: причина', why: 'причина; после глухой "k" - "t"' },
          { answer: 'ım', options: ['ım', 'ın', 'ı'], label: 'моё', why: '' },
        ],
        answer: 'kalktığım', d: 1,
      },
      {
        kind: 'transform', source: 'Hasta olmak için gelemedim.', sourceRu: 'Я не смог прийти, потому что болел.', instruction: 'Исправьте: здесь "потому что", а не "чтобы"',
        answer: 'Hasta olduğum için gelemedim.', variants: [],
        breakdown: [
          { text: 'ol', label: '', why: '' },
          { text: 'duğ', label: '-dığı: причина', why: '"Hasta olmak için" значит "чтобы заболеть"' },
          { text: 'um', label: 'моё', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Я положил документ ему на стол, чтобы директор увидел.', instruction: 'Переведите: увидеть должен другой человек',
        answer: 'Müdür görsün diye belgeyi masasına koydum.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'gör', label: '', why: '' },
          { text: 'sün', label: '"пусть он"', why: 'цель чужая - -sın diye; после "ö" - "ü"' },
          { text: ' diye', label: '"чтобы"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Мы опоздали из-за тебя!', instruction: 'Переведите: ты виноват - какой послелог?',
        answer: 'Senin yüzünden geç kaldık!', variants: [], blankWhole: true,
        breakdown: [{ text: 'yüzünden', label: '"из-за" (плохое)', why: 'yüzünden - о плохом; о хорошем - sayesinde' }], d: 2,
      },
      {
        kind: 'transform', source: 'Из-за аварии мост был закрыт.', instruction: 'Переведите с dolayı',
        answer: 'Kazadan dolayı köprü kapalıydı.', variants: [],
        breakdown: [
          { text: 'kaza', label: '', why: '' },
          { text: 'dan', label: 'откуда? (-den)', why: 'dolayı просит -den' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Он работает, чтобы зарабатывать.', instruction: 'Переведите: цель или причина?',
        answer: 'Para kazanmak için çalışıyor.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kazan', label: '', why: '' },
          { text: 'mak', label: '-mek: цель', why: 'вставляется "чтобы" - -mek için' },
          { text: ' için', label: '', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Он хорошо зарабатывает, потому что много работает.', instruction: 'Переведите: цель или причина?',
        answer: 'Çok çalıştığı için iyi para kazanıyor.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'çalış', label: '', why: '' },
          { text: 'tığ', label: '-dığı: причина', why: 'подходит только "потому что" - -dığı için' },
          { text: 'ı', label: 'его', why: '' },
          { text: ' için', label: '', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Мы приехали с целью помочь.', instruction: 'Переведите официально: "с целью"',
        answer: 'Yardım amacıyla geldik.', variants: [], blankWhole: true,
        breakdown: [{ text: 'amacıyla', label: '"с целью"', why: 'amacıyla - книжная пара к için' }], d: 3,
      },
    ],
  },

  // b1-l042
  {
    rule: 'aspect-meye-baslamak',
    explain: '"Начал работать", "бросил курить", "продолжаю учиться" - действие стоит в форме -mek с падежом. Başlamak и devam etmek спрашивают "куда?" - значит, -meye: çalışmaya başladım, okumaya devam ediyorum. Bırakmak спрашивает "что?" - значит, -meyi: sigara içmeyi bıraktım.',
    examples: [
      {
        parts: [
          { text: 'Geçen yıl çalış', label: '', why: '' },
          { text: 'maya', label: 'куда? (-meye)', why: 'başlamak спрашивает "куда?"; после "a" - -maya' },
          { text: ' başladım.', label: '', why: '' },
        ],
        ru: 'Я начал работать в прошлом году.',
      },
      {
        parts: [
          { text: 'Babam sigara iç', label: '', why: '' },
          { text: 'meyi', label: 'что? (-meyi)', why: 'bırakmak спрашивает "что?"' },
          { text: ' bıraktı.', label: '', why: '' },
        ],
        ru: 'Папа бросил курить.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'çalış', baseRu: 'работать', task: 'куда? (-meye) при başlamak',
        context: { tr: 'Geçen yıl ___ başladım.', ru: 'Я начал работать в прошлом году.' },
        slots: [
          { answer: 'çalış', options: [], label: '', why: '' },
          { answer: 'maya', options: ['maya', 'mayı', 'mak'], label: 'куда? (-meye)', why: 'başlamak спрашивает "куда?"; голый инфинитив, как в русском, не годится' },
        ],
        answer: 'çalışmaya', d: 1,
      },
      {
        kind: 'affix', base: 'iç', baseRu: 'пить (sigara içmek - курить)', task: 'что? (-meyi) при bırakmak',
        context: { tr: 'Babam sigara ___ bıraktı.', ru: 'Папа бросил курить.' },
        slots: [
          { answer: 'iç', options: [], label: '', why: '' },
          { answer: 'meyi', options: ['meyi', 'meye', 'mek'], label: 'что? (-meyi)', why: 'bırakmak спрашивает "что?" - винительный' },
        ],
        answer: 'içmeyi', d: 1,
      },
      {
        kind: 'affix', base: 'öğren', baseRu: 'учить', task: 'куда? (-meye) при devam etmek',
        context: { tr: 'Türkçe ___ devam ediyorum.', ru: 'Я продолжаю учить турецкий.' },
        slots: [
          { answer: 'öğren', options: [], label: '', why: '' },
          { answer: 'meye', options: ['meye', 'meyi', 'mek'], label: 'куда? (-meye)', why: 'devam etmek, как başlamak, хочет дательный' },
        ],
        answer: 'öğrenmeye', d: 1,
      },
      {
        kind: 'affix', base: 'gel', baseRu: 'приходить', task: 'куда? (-meye) при başlamak',
        context: { tr: 'Müşteriler ___ başladı.', ru: 'Клиенты начали приходить.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'meye', options: ['meye', 'maya', 'meyi'], label: 'куда? (-meye)', why: 'после "e" - -meye' },
        ],
        answer: 'gelmeye', d: 1,
      },
      {
        kind: 'transform', source: 'Çalışmak başladım.', sourceRu: 'Я начал работать.', instruction: 'Исправьте ошибку',
        answer: 'Çalışmaya başladım.', variants: [],
        breakdown: [
          { text: 'çalış', label: '', why: '' },
          { text: 'maya', label: 'куда? (-meye)', why: 'инфинитив не остаётся голым: başlamak требует дательный' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'İşi devam ediyorum.', sourceRu: 'Я продолжаю работу.', instruction: 'Исправьте падеж',
        answer: 'İşe devam ediyorum.', variants: [],
        breakdown: [
          { text: 'iş', label: '', why: '' },
          { text: 'e', label: 'куда?', why: 'по-русски "продолжаю работу", но devam etmek хочет дательный' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'В прошлом году я перестал там работать.', instruction: 'Переведите: "перестал" - bıraktım',
        answer: 'Geçen yıl orada çalışmayı bıraktım.', variants: [],
        breakdown: [
          { text: 'çalış', label: '', why: '' },
          { text: 'mayı', label: 'что? (-meyi)', why: 'bırakmak спрашивает "что?"' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Мы по-прежнему каждую неделю пьём кофе.', instruction: 'Переведите: "по-прежнему" - devam ediyoruz',
        answer: 'Her hafta kahve içmeye devam ediyoruz.', variants: [],
        breakdown: [
          { text: 'iç', label: '', why: '' },
          { text: 'meye', label: 'куда? (-meye)', why: 'devam etmek - с -meye' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Пошёл дождь.', instruction: 'Переведите: "начал идти" - başladı',
        answer: 'Yağmur yağmaya başladı.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'yağ', label: '', why: '' },
          { text: 'maya', label: 'куда? (-meye)', why: 'после "a" - -maya' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я ещё не начал работать.', instruction: 'Переведите: отрицание - на втором глаголе',
        answer: 'Henüz çalışmaya başlamadım.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'çalış', label: '', why: '' },
          { text: 'maya', label: 'куда? (-meye)', why: 'отрицание - только у başlamak: başlamadım' },
        ], d: 3,
      },
    ],
  },

  // b1-l043
  {
    rule: 'infinitive-object-mesini-istemek',
    explain: '"Хочу прийти" - Gelmek istiyorum. А "хочу, чтобы ТЫ пришёл" - одно слово с хозяином действия: gel-me-n-i istiyorum: -me - действие, -n - "твоё", -i - "что?". Так же с beklemek и rica etmek: Aramanızı bekliyoruz.',
    examples: [
      {
        parts: [
          { text: 'Gel', label: '', why: '' },
          { text: 'me', label: 'действие (-me)', why: '-mek без k' },
          { text: 'n', label: 'твоё', why: 'хозяин действия - ты' },
          { text: 'i', label: 'что?', why: 'istemek спрашивает "что?"' },
          { text: ' istiyorum.', label: '', why: '' },
        ],
        ru: 'Я хочу, чтобы ты пришёл.',
      },
      {
        parts: [
          { text: 'Ara', label: '', why: '' },
          { text: 'ma', label: 'действие (-me)', why: 'после "a" - -ma' },
          { text: 'nız', label: 'ваше', why: '' },
          { text: 'ı', label: 'что?', why: '' },
          { text: ' bekliyoruz.', label: '', why: '' },
        ],
        ru: 'Ждём вашего звонка.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'gel', baseRu: 'приходить', task: 'действие · твоё · что?',
        context: { tr: '___ istiyorum.', ru: 'Я хочу, чтобы ты пришёл.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'mek', 'ma'], label: 'действие (-me)', why: '-mek без k; "Gelmek istiyorum" - приду я сам' },
          { answer: 'ni', options: ['ni', 'n', 'mi'], label: 'твоё + что?', why: '-n - "твоё", -i - "что?": "gelmen istiyorum" так не говорят' },
        ],
        answer: 'gelmeni', d: 1,
      },
      {
        kind: 'affix', base: 'gel', baseRu: 'приходить', task: 'действие · моё · что?',
        context: { tr: 'Müdür ___ istedi.', ru: 'Директор хотел, чтобы я пришёл.' },
        slots: [
          { answer: 'gel', options: [], label: '', why: '' },
          { answer: 'me', options: ['me', 'mek', 'ma'], label: 'действие (-me)', why: '' },
          { answer: 'mi', options: ['mi', 'ni', 'm'], label: 'моё + что?', why: 'прийти должен я - -m, и винительный -i' },
        ],
        answer: 'gelmemi', d: 1,
      },
      {
        kind: 'affix', base: 'ara', baseRu: 'звонить', task: 'действие · ваше · что?',
        context: { tr: '___ bekliyoruz.', ru: 'Ждём вашего звонка.' },
        slots: [
          { answer: 'ara', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'mak'], label: 'действие (-me)', why: 'после "a" - -ma' },
          { answer: 'nızı', options: ['nızı', 'nız', 'mızı'], label: 'ваше + что?', why: 'beklemek тоже спрашивает "что?"' },
        ],
        answer: 'aramanızı', d: 1,
      },
      {
        kind: 'affix', base: 'yaz', baseRu: 'писать', task: 'действие · его · что?',
        context: { tr: 'Ali\'nin ___ bekliyoruz.', ru: 'Ждём, когда Али напишет.' },
        slots: [
          { answer: 'yaz', options: [], label: '', why: '' },
          { answer: 'ma', options: ['ma', 'me', 'mak'], label: 'действие (-me)', why: '' },
          { answer: 'sını', options: ['sını', 'sı', 'nı'], label: 'его + что?', why: 'в 3-м лице -sı, и перед винительным появляется n' },
        ],
        answer: 'yazmasını', d: 1,
      },
      {
        kind: 'transform', source: 'Gelmek istiyorum.', sourceRu: 'Я хочу прийти.', instruction: 'Скажите: "Я хочу, чтобы ты пришёл"',
        answer: 'Gelmeni istiyorum.', variants: ['Senin gelmeni istiyorum.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'me', label: 'действие (-me)', why: '' },
          { text: 'ni', label: 'твоё + что?', why: 'приходить будешь ты - хозяин действия внутри слова' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Я хочу, чтобы ты не приходил.', instruction: 'Переведите: отрицание - внутри слова',
        answer: 'Gelmemeni istiyorum.', variants: ['Senin gelmemeni istiyorum.'],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'me', label: 'не', why: 'отрицание - сразу после основы' },
          { text: 'me', label: 'действие (-me)', why: '' },
          { text: 'ni', label: 'твоё + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Они хотели, чтобы мы пришли в десять.', instruction: 'Переведите: прийти должны мы',
        answer: 'Saat onda gelmemizi istediler.', variants: [],
        breakdown: [
          { text: 'gel', label: '', why: '' },
          { text: 'me', label: 'действие (-me)', why: '' },
          { text: 'mizi', label: 'наше + что?', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Просим вас прислать резюме.', instruction: 'Переведите: "у кого просим" - sizden',
        answer: 'Sizden özgeçmişinizi göndermenizi istiyoruz.', variants: ['Özgeçmişinizi göndermenizi istiyoruz.'],
        breakdown: [
          { text: 'gönder', label: '', why: '' },
          { text: 'me', label: 'действие (-me)', why: '' },
          { text: 'nizi', label: 'ваше + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Я не хочу, чтобы ты ждал.', instruction: 'Переведите: ждать будешь ты',
        answer: 'Beklemeni istemiyorum.', variants: ['Senin beklemeni istemiyorum.'],
        breakdown: [
          { text: 'bekle', label: '', why: '' },
          { text: 'me', label: 'действие (-me)', why: '"Beklemek istemiyorum" - не хочу ждать я сам' },
          { text: 'ni', label: 'твоё + что?', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Учитель хочет, чтобы ученики написали.', instruction: 'Переведите: хозяин действия - ученики (в родительном)',
        answer: 'Öğretmen öğrencilerin yazmalarını istiyor.', variants: ['Öğretmen öğrencilerin yazmasını istiyor.'],
        breakdown: [
          { text: 'yaz', label: '', why: '' },
          { text: 'ma', label: 'действие (-me)', why: '' },
          { text: 'larını', label: 'их + что?', why: '-ları - "их", перед винительным - n' },
        ], d: 3,
      },
    ],
  },

  // b1-l046
  {
    rule: 'mek-uzere',
    explain: '-mek üzere - это "вот-вот, уже почти": Toplantı başlamak üzere. Глагол остаётся в словарной форме на -mek, а "я, ты, мы" прибавляются к üzere: çıkmak üzereyim, üzereyiz. В прошедшем - -ydı: Tam çıkmak üzereydim, telefon çaldı.',
    examples: [
      {
        parts: [
          { text: 'Çıkmak üzere', label: '', why: '' },
          { text: 'yim', label: 'я', why: 'глагол не меняется, лицо - только на üzere' },
        ],
        ru: 'Я вот-вот выйду, уже выхожу.',
      },
      {
        parts: [
          { text: 'Toplantı başla', label: '', why: '' },
          { text: 'mak', label: '-mek', why: 'словарная форма; "вот-вот" - не -acak' },
          { text: ' üzere.', label: '"вот-вот"', why: '' },
        ],
        ru: 'Встреча вот-вот начнётся.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'üzere', baseRu: 'вот-вот', task: 'я',
        context: { tr: 'Çıkmak ___.', ru: 'Я уже выхожу.' },
        slots: [
          { answer: 'üzere', options: [], label: '', why: '' },
          { answer: 'yim', options: ['yim', 'im', 'sin'], label: 'я', why: 'как hazırım, но после гласной - y' },
        ],
        answer: 'üzereyim', d: 1,
      },
      {
        kind: 'affix', base: 'üzere', baseRu: 'вот-вот', task: 'мы',
        context: { tr: 'Biz de çıkmak ___.', ru: 'Мы тоже вот-вот выйдем.' },
        slots: [
          { answer: 'üzere', options: [], label: '', why: '' },
          { answer: 'yiz', options: ['yiz', 'iz', 'ler'], label: 'мы', why: 'после гласной - y' },
        ],
        answer: 'üzereyiz', d: 1,
      },
      {
        kind: 'affix', base: 'başla', baseRu: 'начинаться', task: '-mek перед üzere',
        context: { tr: 'Toplantı ___ üzere.', ru: 'Встреча вот-вот начнётся.' },
        slots: [
          { answer: 'başla', options: [], label: '', why: '' },
          { answer: 'mak', options: ['mak', 'yacak', 'dı'], label: '-mek', why: 'перед üzere глагол всегда в словарной форме на -mak / -mek' },
        ],
        answer: 'başlamak', d: 1,
      },
      {
        kind: 'affix', base: 'üzere', baseRu: 'вот-вот', task: 'прошедшее · я',
        context: { tr: 'Tam çıkmak ___, telefon çaldı.', ru: 'Я уже собирался выходить, и тут зазвонил телефон.' },
        slots: [
          { answer: 'üzere', options: [], label: '', why: '' },
          { answer: 'ydim', options: ['ydim', 'yim', 'ceğim'], label: 'прошедшее · я', why: 'в прошедшем - знакомое -ydı' },
        ],
        answer: 'üzereydim', d: 1,
      },
      {
        kind: 'transform', source: 'Toplantı başlayacak.', sourceRu: 'Встреча начнётся.', instruction: 'Скажите, что встреча начнётся вот-вот, через минуту',
        answer: 'Toplantı başlamak üzere.', variants: [],
        breakdown: [
          { text: 'başla', label: '', why: '' },
          { text: 'mak', label: '-mek', why: '-acak - просто "начнётся", может, завтра' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Çıkacağım üzere.', sourceRu: 'Я вот-вот выйду.', instruction: 'Исправьте: лицо - только на üzere',
        answer: 'Çıkmak üzereyim.', variants: ['Ben çıkmak üzereyim.'],
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'mak', label: '-mek', why: 'глагол не меняется никогда' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
          { text: 'yim', label: 'я', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Yağmur yağmaya başladı.', sourceRu: 'Пошёл дождь.', instruction: 'Скажите, что дождь ещё не пошёл, но вот-вот пойдёт',
        answer: 'Yağmur yağmak üzere.', variants: [],
        breakdown: [
          { text: 'yağ', label: '', why: '' },
          { text: 'mak', label: '-mek', why: '-meye başladı - уже началось, -mek üzere - ещё нет' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'До встречи! (в конце письма коллеге)', instruction: 'Переведите прощание',
        answer: 'Görüşmek üzere!', variants: ['Görüşmek üzere.'], blankWhole: true,
        breakdown: [
          { text: 'görüş', label: '', why: '' },
          { text: 'mek', label: '-mek', why: '' },
          { text: ' üzere', label: '"с тем чтобы"', why: 'старое значение üzere: "расстаёмся, чтобы снова увидеться"' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Ваша посылка вот-вот будет доставлена.', instruction: 'Переведите: пассив + üzere',
        answer: 'Paketiniz teslim edilmek üzere.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'edil', label: '', why: '' },
          { text: 'mek', label: '-mek', why: 'с пассивом тоже работает: edilmek üzere' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Ты вот-вот опоздаешь!', instruction: 'Переведите: лицо - на üzere',
        answer: 'Geç kalmak üzeresin!', variants: [], blankWhole: true,
        breakdown: [
          { text: 'kal', label: '', why: '' },
          { text: 'mak', label: '-mek', why: '' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
          { text: 'sin', label: 'ты', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Мы уже собирались выходить (и тут...).', instruction: 'Переведите: прошедшее - на üzere',
        answer: 'Çıkmak üzereydik.', variants: ['Biz çıkmak üzereydik.'], blankWhole: true,
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'mak', label: '-mek', why: '' },
          { text: ' üzere', label: '"вот-вот"', why: '' },
          { text: 'ydik', label: 'прошедшее · мы', why: '' },
        ], d: 3,
      },
    ],
  },

  // b1-l055
  {
    rule: 'passive-reported-digi',
    explain: 'Когда неважно, кто сообщил, клаузу на -dığı ставят перед пассивом: Sınavın ertelendiği açıklandı - "объявлено, что экзамен перенесли". Клауза становится подлежащим, поэтому винительного -nı нет: ertelendiği, а не ertelendiğini. О будущем - -eceği: Köprünün yarın açılacağı açıklandı.',
    examples: [
      {
        parts: [
          { text: 'Sınavın ertelen', label: '', why: '' },
          { text: 'diği', label: '-dığı, без -nı', why: 'глагол в пассиве - клауза подлежащее, винительного нет' },
          { text: ' açıklandı', label: 'пассив', why: '"объявлено" - неважно кем' },
        ],
        ru: 'Объявлено, что экзамен перенесли.',
      },
      {
        parts: [
          { text: 'Köprünün yarın açıl', label: '', why: '' },
          { text: 'acağı', label: '-eceği, без -nı', why: 'о будущем - -eceği' },
          { text: ' açıklandı', label: 'пассив', why: '' },
        ],
        ru: 'Объявлено, что мост откроют завтра.',
      },
    ],
    items: [
      {
        kind: 'affix', base: 'ertelen', baseRu: 'переноситься', task: '"то, что" (-dığı) · его · без винительного -nı',
        context: { tr: 'Sınavın ___ açıklandı.', ru: 'Объявлено, что экзамен перенесли.' },
        slots: [
          { answer: 'ertelen', options: [], label: '', why: '' },
          { answer: 'diğ', options: ['diğ', 'dığ', 'eceğ'], label: '-dığı', why: 'перенесли - прошлое; после "e" - "i"' },
          { answer: 'i', options: ['i', 'ini', 'im'], label: 'его', why: 'açıklandı - пассив, клауза подлежащее: без -ni' },
        ],
        answer: 'ertelendiği', d: 1,
      },
      {
        kind: 'affix', base: 'açıl', baseRu: 'открываться', task: 'будущее (-eceği) · его · без винительного -nı',
        context: { tr: 'Köprünün yarın ___ açıklandı.', ru: 'Объявлено, что мост откроют завтра.' },
        slots: [
          { answer: 'açıl', options: [], label: '', why: '' },
          { answer: 'acağ', options: ['acağ', 'dığ', 'eceğ'], label: '-eceği: будущее', why: 'yarın - будущее; после "ı" - -acağ' },
          { answer: 'ı', options: ['ı', 'ını', 'ım'], label: 'его', why: 'пассив - без -nı' },
        ],
        answer: 'açılacağı', d: 1,
      },
      {
        kind: 'affix', base: 'ol', baseRu: 'быть', task: '"то, что" (-dığı) · его · без винительного -nı',
        context: { tr: 'Yolun kapalı ___ bildirildi.', ru: 'Сообщается, что дорога закрыта.' },
        slots: [
          { answer: 'ol', options: [], label: '', why: '' },
          { answer: 'duğ', options: ['duğ', 'dığ', 'mak'], label: '-dığı', why: 'имя берёт olduğu; после "o" - "u"' },
          { answer: 'u', options: ['u', 'unu', 'um'], label: 'его', why: 'bildirildi - пассив: без -nu' },
        ],
        answer: 'olduğu', d: 1,
      },
      {
        kind: 'affix', base: 'açıkla', baseRu: 'объявлять', task: 'кто-то объявил',
        context: { tr: 'Belediye köprünün açılacağını ___.', ru: 'Мэрия объявила, что мост откроют.' },
        slots: [
          { answer: 'açıkla', options: [], label: '', why: '' },
          { answer: 'dı', options: ['dı', 'ndı', 'nıldı'], label: 'действительный залог', why: 'есть кто объявил - belediye; клауза - дополнение, отсюда -nı' },
        ],
        answer: 'açıkladı', d: 2,
      },
      {
        kind: 'transform', source: 'Sınavın ertelendiğini açıklandı.', sourceRu: 'Объявлено, что экзамен перенесли.', instruction: 'Исправьте ошибку',
        answer: 'Sınavın ertelendiği açıklandı.', variants: ['Sınavın ertelendiği bildirildi.'],
        breakdown: [
          { text: 'ertelen', label: '', why: '' },
          { text: 'diği', label: '-dığı, без -ni', why: 'глагол в пассиве - в клаузе -dığı без -nı' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Polis kimsenin yaralanmadığını bildirdi.', sourceRu: 'Полиция сообщила, что никто не пострадал.', instruction: 'Уберите полицию: "Сообщается, что..."',
        answer: 'Kimsenin yaralanmadığı bildirildi.', variants: [],
        breakdown: [
          { text: 'yaralan', label: '', why: '' },
          { text: 'ma', label: 'не', why: '' },
          { text: 'dığı', label: '-dığı, без -nı', why: 'клауза стала подлежащим - -nı отпадает' },
          { text: ' bildirildi', label: 'пассив', why: 'bildirdi - bildirildi' },
        ], d: 2,
      },
      {
        kind: 'transform', source: 'Объявлено, что результаты выйдут в пятницу.', instruction: 'Переведите: будущее, пассив',
        answer: 'Sonuçların cuma çıkacağı açıklandı.', variants: ['Sonuçların cuma çıkacağı bildirildi.'], blankWhole: true,
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'acağı', label: '-eceği, без -nı', why: '' },
          { text: ' açıklandı', label: 'пассив', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Стало известно, что пожар начался из-за проводки.', instruction: 'Переведите: "стало известно" - öğrenildi',
        answer: 'Yangının elektrikten çıktığı öğrenildi.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'çık', label: '', why: '' },
          { text: 'tığı', label: '-dığı, без -nı', why: 'после глухой "k" - "t"' },
          { text: ' öğrenildi', label: 'пассив', why: '' },
        ], d: 3,
      },
      {
        kind: 'transform', source: 'Сообщается, что ночью будет сильный снег.', instruction: 'Переведите: будущее, "сообщается" - bildirildi',
        answer: 'Gece çok kar yağacağı bildirildi.', variants: [], blankWhole: true,
        breakdown: [
          { text: 'yağ', label: '', why: '' },
          { text: 'acağı', label: '-eceği, без -nı', why: '' },
          { text: ' bildirildi', label: 'пассив', why: '' },
        ], d: 3,
      },
    ],
  },
]
